// extracted by mini-css-extract-plugin
export default {"List":"list-shared-module--List--B6wlI"};